// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../config/api";
import config from "../../config/config";
import { getCurrentLoggedInSessionToken } from "../../config/userPool";

const {
  SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT,
  SHUTTLE_BUS_BOOKING_ROUTE_DETAIL_ENDPOINT,
  SHUTTLE_BUS_BOOKING_ROUTE_DELETE_ENDPOINT,
  AUDIT_ENDPOINT,

} = config.api_endpoint;

const initialState = {
  loading: false,
  ordinary_route_list: [],
  special_route_list: [],
  error: null,
  detail_loading: false,
  detail_data: {},
  special_detail_loading: false,
  special_detail_data: {},
  detail_error: null,
  audit_data: [],
  special_route_audit_data: [],
  audit_loading: false,
  audit_error: null,
};


export const fetchOrdinaryRouteList = createAsyncThunk(
  "route/fetchOrdinaryRouteList",
  async (_, { rejectWithValue }) => {
    console.log('erewreaw');

    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}`;


      const results = await api.get(url, {}, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchSpecialRouteList = createAsyncThunk(
  "route/fetchSpecialRouteList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/special-days`;


      const results = await api.get(url, {}, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchRouteDetail = createAsyncThunk(
  "route/fetchRouteDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        SHUTTLE_BUS_BOOKING_ROUTE_DETAIL_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchSpecialRouteDetail = createAsyncThunk(
  "route/fetchSpecialRouteDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        SHUTTLE_BUS_BOOKING_ROUTE_DETAIL_ENDPOINT + "/special-days/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const updateRouteStatus = createAsyncThunk(
  "route/updateRouteStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/${id}/status`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;



    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const updateSpecialRouteStatus = createAsyncThunk(
  "route/updateSpecialRouteStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/special-days/${id}/status`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;



    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const createAndUpdateRoute = createAsyncThunk(
  "route/createAndUpdateRoute",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      if (id) {
        const results = await api.put(
          `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const createAndUpdateSpecialRoute = createAsyncThunk(
  "route/createAndUpdateSpecialRoute",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      if (id) {
        const results = await api.put(
          `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/special-days/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${SHUTTLE_BUS_BOOKING_ROUTE_LISTING_ENDPOINT}/special-days`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const deleteRouteById = createAsyncThunk(
  "route/deleteRouteById",
  async (id, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        SHUTTLE_BUS_BOOKING_ROUTE_DELETE_ENDPOINT + "/" + id,
        JSON.stringify({ }),
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const deleteSpecialRouteById = createAsyncThunk(
  "route/deleteSpecialRouteById",
  async (id, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        SHUTTLE_BUS_BOOKING_ROUTE_DELETE_ENDPOINT + "/special-days/" + id,
        JSON.stringify({ }),
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const fetchRouteAudit = createAsyncThunk(
  "route/fetchRouteAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=bus_booking-route&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchSpecialRouteAudit = createAsyncThunk(
  "route/fetchSpecialRouteAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=bus_booking-special_days&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const RouteSlice = createSlice({
  name: "route",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRouteDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchRouteDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.detail_data = action.payload;
      })
      .addCase(fetchRouteDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchSpecialRouteDetail.pending, (state) => {
        state.special_detail_loading = true;
      })
      .addCase(fetchSpecialRouteDetail.fulfilled, (state, action) => {
        state.special_detail_loading = false;
        state.special_detail_data = action.payload;
      })
      .addCase(fetchSpecialRouteDetail.rejected, (state, action) => {
        state.special_detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchRouteAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchRouteAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.audit_data = action.payload;
      })
      .addCase(fetchRouteAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(fetchSpecialRouteAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchSpecialRouteAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.special_route_audit_data = action.payload;
      })
      .addCase(fetchSpecialRouteAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(fetchOrdinaryRouteList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrdinaryRouteList.fulfilled, (state, action) => {
        state.loading = false;
        state.ordinary_route_list = action.payload;
      })
      .addCase(fetchOrdinaryRouteList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchSpecialRouteList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSpecialRouteList.fulfilled, (state, action) => {
        state.loading = false;
        state.special_route_list = action.payload;
      })
      .addCase(fetchSpecialRouteList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateRouteStatus.pending, (state) => {
        state.loading = true;
        state.detail_loading = true;
      })
      .addCase(updateRouteStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
      .addCase(updateRouteStatus.rejected, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
      .addCase(updateSpecialRouteStatus.pending, (state) => {
        state.loading = true;
        state.detail_loading = true;
      })
      .addCase(updateSpecialRouteStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
      .addCase(updateSpecialRouteStatus.rejected, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
  },
});

const ShuttleBusRouteReducer = RouteSlice.reducer;
export default ShuttleBusRouteReducer;
